module.exports = __webpack_public_path__ + "static/media/ifeno_logo_blanco.b47314ab.png";